<editor [id]="editorId" [init]="editorConfig" [(ngModel)]="value" (ngModelChange)="changeValue()"></editor>
<app-upload-file
    [uploadElementId]="'upload'+ editorId"
    #uploadImage
    style="display: none"
    [needJudgeFileType]="true"
    [accept]="accept"
    (selectFile)="upload($event)"
></app-upload-file>
